// extracted by mini-css-extract-plugin
export default {"preloader":"Preloader_preloader__YoHf7","imagePreloader":"Preloader_imagePreloader__CKkdr"};